import { Flex, Text } from "@chakra-ui/react";

import { WarningBadgeTooltip } from "@/common/components/InfoIconTooltip";
import { DebugEvent } from "@reflag/shared/eventAPI";

function ellipsis(input: string, maxLength: number) {
  return input.length > maxLength
    ? input.substring(0, maxLength) + "..."
    : input;
}

export const satisfactionScoreToText = (score: number) => {
  if (score === 1) return "very unsatisfied";
  if (score === 2) return "unsatisfied";
  if (score === 3) return "neutral";
  if (score === 4) return "satisfied";
  if (score === 5) return "very satisfied";
  return "-";
};

export function EventCell({ event }: { event: DebugEvent }) {
  const mapping = {
    check: {
      primary: event.featureFlagEvent?.featureKey || "-",
      secondary: event.featureFlagEvent?.evalResult ? "enabled" : "disabled",
    },
    "check-config": {
      primary: event.featureFlagEvent?.featureKey || "-",
      secondary: event.featureFlagEvent?.evalConfig?.key ?? "-",
    },
    track: {
      primary: event?.name || "-",
      secondary:
        (event.attributes ? Object.keys(event?.attributes).length : 0) +
        " attributes",
    },
    user: {
      primary: event.user?.id || "-",
      secondary:
        (event.attributes ? Object.keys(event?.attributes).length : 0) +
        " attributes",
    },
    company: {
      primary: event.company?.id || "-",
      secondary:
        (event.attributes ? Object.keys(event?.attributes).length : 0) +
        " attributes",
    },
    feedback: {
      primary: `"${ellipsis(event.feedback?.comment || "-", 50)}"`,
      secondary: satisfactionScoreToText(event.feedback?.score || 0),
    },
    unknown: {
      primary: "-",
      secondary: "",
    },
  };

  const { primary, secondary } =
    mapping[event.debugEventType in mapping ? event.debugEventType : "unknown"];
  const hasEvaluationErrors =
    (event.featureFlagEvent?.evalErrors?.length ?? 0) > 0;

  return (
    <Flex alignItems={"center"} fontSize="sm" gap={2}>
      <Text isTruncated>{primary}</Text>
      <Text color="dimmed" isTruncated>
        {secondary}
      </Text>
      {hasEvaluationErrors && (
        <WarningBadgeTooltip text="This event has evaluation diagnostics. The evaluation may not work as expected." />
      )}
    </Flex>
  );
}
